
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    open: [],
  }),
  methods: {
    toggleItem(index) {
      if (this.open.includes(index)) {
        this.open = this.open.filter(item => item !== index);
      } else {
        this.open.push(index);
      }
    },
  },
};
